import { connect } from 'react-redux'

import { BookingOptionsBase } from './BookingOptions'

import { bookingActions } from 'reduxModules/actions/BookingActions'
import { blacklistActions } from 'reduxModules/actions/BlacklistActions'
import { modalActions } from 'reduxModules/actions/ModalActions'

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  deleteBooking: bookingActions.deleteBooking,
  setBookingStatus: bookingActions.setBookingStatus,
  addBlacklistBooking: blacklistActions.addBlacklistBooking,
}

export const BookingOptions = connect(null, mapDispatchToProps)(BookingOptionsBase)



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingOptions/index.js